export default {
  expensesFor: 'Orders for {month}',
  clickTooltip: 'Click a name for more details',
  name: 'Name',
  days: 'Days',
  cost: 'Cost',
  totalCost: 'Total: {total}€',
  hasBeenPaid: 'Paid',
  date: 'Date',
  soup: 'Soup(s)',
  mainDish: 'Main dish(es)',
  actualPrice: 'Price',
  paidPrice: 'Price',
  city: 'City',
};
